import { SETDONORINFO } from '../../actions/donorList';

const initialState = {
  donorInfo: [],
};

export const DonorStateReducer = (state = initialState, action) => {
  switch (action.type) {
    case SETDONORINFO:
      return {
        ...state,
        donorInfo: action.payload, // ✅ update state
      };

    default:
      return state;
  }
};
